module.exports = __webpack_public_path__ + "static/media/settings_border_selected.fdd7fa62.svg";